
const StylePanel = () => {

    return <div className='styleArea'>
    </div>
}
export default StylePanel;